import axios from '../AxiosInstance';
import { getApiUrl } from '../../utils/ApiUtils';

const base = (companyId) => `${companyId}/expenses`;

export const getExpenses = (companyId, params) =>
  axios.get(getApiUrl(base(companyId)), { params, withCredentials: true });

export const getExpense = (companyId, expenseId) =>
  axios.get(getApiUrl(`${base(companyId)}/${expenseId}`), { withCredentials: true });

export const createExpense = (companyId, data) =>
  axios.post(getApiUrl(base(companyId)), data, { withCredentials: true });

export const updateExpense = (companyId, expenseId, data) =>
  axios.put(getApiUrl(`${base(companyId)}/${expenseId}`), data, { withCredentials: true });

export const deleteExpense = (companyId, expenseId) =>
  axios.delete(getApiUrl(`${base(companyId)}/${expenseId}`), { withCredentials: true });

export const submitExpense = (companyId, expenseId) =>
  axios.post(getApiUrl(`${base(companyId)}/${expenseId}/submit`), {}, { withCredentials: true });

export const approveExpense = (companyId, expenseId) =>
  axios.post(getApiUrl(`${base(companyId)}/${expenseId}/approve`), {}, { withCredentials: true });

export const rejectExpense = (companyId, expenseId, reason) =>
  axios.post(getApiUrl(`${base(companyId)}/${expenseId}/reject`), { reason }, { withCredentials: true });

// Admin queue: all expenses across the company (filter by status).
export const getAdminExpenses = (companyId, params) =>
  axios.get(getApiUrl(`${base(companyId)}/admin/all`), { params, withCredentials: true });

// Booking flow: preview the verifikat rows, then commit. Optional overrides
// let the modal render a live preview as the user types missing VAT,
// distance_km, participants, etc. without saving them first.
export const previewExpenseBooking = (companyId, expenseId, overrides) =>
  axios.get(getApiUrl(`${base(companyId)}/${expenseId}/book/preview`), {
    params: overrides || {},
    withCredentials: true,
  });

// Audit trail — returns verifikat(er) linked via verification_references
// (both expense_booking + expense_settlement types).
export const listExpenseVerifications = (companyId, expenseId) =>
  axios.get(getApiUrl(`${base(companyId)}/${expenseId}/verifications`), { withCredentials: true });

export const bookExpense = (companyId, expenseId, body = {}) =>
  axios.post(getApiUrl(`${base(companyId)}/${expenseId}/book`), body, { withCredentials: true });

// Reverses a booked expense — posts an offsetting verifikat, status → approved.
export const unbookExpense = (companyId, expenseId, body) =>
  axios.post(getApiUrl(`${base(companyId)}/${expenseId}/unbook`), body, { withCredentials: true });

// Settlement (booked → settled)
export const previewExpenseSettlement = (companyId, expenseId) =>
  axios.get(getApiUrl(`${base(companyId)}/${expenseId}/settle/preview`), { withCredentials: true });

export const settleExpense = (companyId, expenseId, body) =>
  axios.post(getApiUrl(`${base(companyId)}/${expenseId}/settle`), body, { withCredentials: true });

// Bulk settlement — one verifikat covers all expenseIds at once. Used when
// the admin makes a single clump-sum bank payment for many expenses.
export const settleExpensesBulk = (companyId, body) =>
  axios.post(getApiUrl(`${base(companyId)}/settle-bulk`), body, { withCredentials: true });

export const analyzeReceipt = (companyId, file) => {
  const formData = new FormData();
  formData.append('file', file);
  return axios.post(getApiUrl(`${base(companyId)}/analyze-receipt`), formData, {
    withCredentials: true,
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};
